// Canonical sidebar menu configuration.
// `roles` limits the menu to specific roles; `superuserProtected` means a
// superuser cannot hide the menu via the "Manage Users & Roles" edit modal.

export const MAIN_MENUS = [
  { key: "dashboard", labelKey: "sidebar.links.dashboard", to: "/dashboard", section: "overview", superuserProtected: true },
  { key: "consultants", labelKey: "sidebar.links.consultants", to: "/consultants", section: "directory" },
  { key: "clients", labelKey: "sidebar.links.clients", to: "/clients", section: "directory" },
  { key: "vendors", labelKey: "sidebar.links.vendors", to: "/vendors", section: "directory" },
  { key: "missions", labelKey: "sidebar.links.missions", to: "/missions", section: "delivery" },
  { key: "contracts", labelKey: "sidebar.links.contracts", to: "/contracts", section: "delivery" },
  { key: "timesheets", labelKey: "sidebar.links.timesheets", to: "/timesheets", section: "delivery" },
  { key: "invoices", labelKey: "sidebar.links.invoices", to: "/invoices", section: "billing" },
  { key: "payments", labelKey: "sidebar.links.payments", to: "/payments", section: "billing" },
];

export const ADMIN_MENUS = [
  { key: "finance", labelKey: "sidebar.links.finance", to: "/finance", section: "operations", roles: ["admin", "superuser"], superuserProtected: true },
  { key: "expenses", labelKey: "sidebar.links.expenses", to: "/expenses", section: "operations", roles: ["admin", "superuser"], superuserProtected: true },
  { key: "history", labelKey: "sidebar.links.history", to: "/dashboard/history/invoices", section: "operations", roles: ["admin", "superuser"], superuserProtected: true },
  { key: "settings", labelKey: "sidebar.links.settings", to: "/settings", section: "system", roles: ["admin", "superuser"], superuserProtected: true },
  { key: "options", labelKey: "sidebar.links.options", to: "/options", section: "system", roles: ["superuser"], superuserProtected: true },
];

export const USER_GUIDE_MENU = { key: "userGuide", labelKey: "sidebar.links.userGuide", to: "/user-guide" };

export const ALL_MENUS = [...MAIN_MENUS, ...ADMIN_MENUS, USER_GUIDE_MENU];
